export enum PMJobRunSupportLevel {
    all = 'all',
    development = 'development',
    production = 'production',
    qaReview = 'qa-review',
    inactive = 'inactive',
    static = 'static',
    unknown = 'unknown'
}
